import { Sword, User, MapPin, Package, Flag, Sparkles, Truck, Building2, Tag } from "lucide-react";

export const ENTITY_TYPES = {
  character: { label: "Character", icon: User, color: "red", plural: "Characters" },
  weapon: { label: "Weapon", icon: Sword, color: "amber", plural: "Weapons" },
  location: { label: "Location", icon: MapPin, color: "emerald", plural: "Locations" },
  object: { label: "Object", icon: Package, color: "violet", plural: "Objects" },
  faction: { label: "Faction", icon: Flag, color: "sky", plural: "Factions" },
  vehicle: { label: "Vehicle", icon: Truck, color: "cyan", plural: "Vehicles" },
  building: { label: "Building", icon: Building2, color: "stone", plural: "Buildings" },
};

export const TYPE_ORDER = ["character", "weapon", "location", "object", "faction", "vehicle", "building"];

export const TYPE_DOT = {
  red: "#ef4444", amber: "#f59e0b", emerald: "#10b981",
  violet: "#8b5cf6", sky: "#0ea5e9", cyan: "#06b6d4", stone: "#a8a29e",
};

export function entityClass(type) {
  return `entity-hl entity-${type}`;
}

const OWNER_BUILTINS = ["character", "vehicle", "building"];

// Resolve a type key (built-in or project custom) to display metadata with a hex colour.
export function resolveType(type, customTypes = []) {
  const m = ENTITY_TYPES[type];
  if (m) {
    return { key: type, label: m.label, plural: m.plural, icon: m.icon,
      color: TYPE_DOT[m.color], isOwner: OWNER_BUILTINS.includes(type), custom: false };
  }
  const c = (customTypes || []).find((t) => t.key === type);
  if (c) {
    return { key: type, label: c.label, plural: c.label, icon: Tag,
      color: c.color || "#94a3b8", isOwner: !!c.is_owner, custom: true };
  }
  return { key: type, label: type, plural: type, icon: Tag, color: "#94a3b8", isOwner: false, custom: true };
}

// Full list of selectable types (built-ins + custom).
export function allTypes(customTypes = []) {
  return [...TYPE_ORDER.map((k) => resolveType(k)),
    ...(customTypes || []).map((c) => resolveType(c.key, customTypes))];
}

export const AI_ICON = Sparkles;

// Shared palette for custom types + slug helper.
export const TYPE_SWATCHES = ["#ef4444", "#f59e0b", "#eab308", "#84cc16", "#10b981", "#14b8a6",
  "#0ea5e9", "#6366f1", "#8b5cf6", "#ec4899", "#f43f5e", "#78716c"];

export const slugType = (s) =>
  "c_" + s.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
